<p style="font-size: 18px">Consumption by {{ title }}</p>

<usimweb-plot [data]="projectGraph.data" [layout]="projectGraph.layout"></usimweb-plot>

<p style="font-size: 18px">Consumption by type</p>

<usimweb-plot [data]="typGraph.data" [layout]="typGraph.layout"></usimweb-plot>
